import fetch from '@/plugin/axios'

// 表单列表
export function getFormList (query) {
  return fetch({
    url: '/api/order/info-table/list',
    method: 'Post',
    data: query
  })
}

// 添加表单
export function addFormDetails (query) {
  return fetch({
    url: '/api/order/info-table/add',
    method: 'Post',
    data: query
  })
}

// 获取表单信息
export function getFormDetailList (id) {
  return fetch({
    url: '/api/order/info-table/info/' + id,
    method: 'Get'
  })
}

// 修改表单信息
export function updateFormDetailList (id, query) {
  return fetch({
    url: '/api/order/info-table/update/' + id,
    method: 'Post',
    data: query
  })
}

// 记录列表
export function getRecordList (query) {
  return fetch({
    url: '/api/order/info-table-record/list',
    method: 'Post',
    data: query
  })
}

// 记录审核
export function getRecordAudit (data) {
  return fetch({
    url: '/api/order/info-table-record/audit',
    method: 'Post',
    params: data
  })
}

// 记录详情
export function getRecordDetail (id) {
  return fetch({
    url: '/api/order/info-table-record/info/' + id,
    method: 'Get'
  })
}
